import { EyeIcon } from "@heroicons/react/24/outline";
import { Accordion, AccordionItem, Button, Card, CardBody, CardHeader, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, TableCell, TableRow, useDisclosure } from "@nextui-org/react";
import ClientTablePagination from "../../../../elements/ClientTablePagination";

export default function ModalDetailPreviewTransport({ item }) {
    const {isOpen, onOpen, onOpenChange} = useDisclosure();
    const header = ['Perusahaan Tujuan Bongkar', 'Alamat Kantor', 'Jumlah Di Bongkar'];

    console.log(item);
    
    const content = (item, index) => (
        <TableRow key={index}>
            <TableCell>{item?.namaPerusahaan}</TableCell>
            <TableCell>{item?.alamat}</TableCell>
            <TableCell>{item?.jumlahDiBongkar} Kg</TableCell>
        </TableRow>
    )

    return (
        <>
            <Button isIconOnly size="sm" color="primary" onPress={onOpen}><EyeIcon className="size-4" /></Button>
            <Modal scrollBehavior="inside" size="3xl" isOpen={isOpen} onOpenChange={onOpenChange}>
                <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1">Detail Pengangkutan</ModalHeader>
                        <ModalBody>
                            <Accordion isCompact defaultExpandedKeys={["0"]}>
                                    {
                                        item?.map((item, index) => (
                                            <AccordionItem 
                                                key={index} 
                                                aria-label={`Accordion ${index}`} 
                                                title={item.b3Substance.name}
                                                subtitle={item.b3Substance.casNumber}
                                            >
                                                {item.asalMuat.map((itemAm, indexAm) => (
                                                    <Card radius='none' className='mb-3'>
                                                        <CardHeader className='text-xs text-ink-500 flex flex-col items-start'>
                                                            <span>Perusahaan Asal Muat</span>
                                                            <span className=''>Nama:  {itemAm.namaPerusahaan}</span>
                                                        </CardHeader>
                                                        <CardBody>
                                                            <ClientTablePagination header={header} content={content} data={itemAm.tujuanBongkar} />
                                                        </CardBody>
                                                    </Card>
                                                ))}
                                            </AccordionItem>
                                        ))
                                    }
                            </Accordion>     
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" variant="light" onPress={onClose}>
                                Tutup
                            </Button>
                        </ModalFooter>
                    </>
                )}
                </ModalContent>
            </Modal>
        </>
    )
}
